import { Group, Text } from "@mantine/core";
import i18n from "../i18n/i18n";
import { useState, useEffect } from "react";

/**
 * Language switcher component that allows users to switch between languages
 * and properly indicates the current language
 */
const LanguageSwitcher: React.FC = () => {
  // Keep track of the current language to force re-renders when it changes
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

  // Set up a language change listener to update the UI
  useEffect(() => {
    const handleLanguageChange = (lng: string) => {
      setCurrentLanguage(lng);
    };

    // Listen for language changes
    i18n.on("languageChanged", handleLanguageChange);

    // Clean up
    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, []);

  // Function to handle language selection
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    // Also update local state for immediate UI feedback
    setCurrentLanguage(lng);
  };

  return (
    <Group gap="xs">
      <Text
        onClick={() => changeLanguage("en")}
        style={{
          fontWeight: currentLanguage === "en" ? 700 : 400,
          cursor: "pointer",
          textDecoration: currentLanguage === "en" ? "underline" : "none",
        }}
      >
        EN
      </Text>
      <Text>|</Text>
      <Text
        onClick={() => changeLanguage("pt-PT")}
        style={{
          fontWeight: currentLanguage === "pt-PT" ? 700 : 400,
          cursor: "pointer",
          textDecoration: currentLanguage === "pt-PT" ? "underline" : "none",
        }}
      >
        PT
      </Text>
    </Group>
  );
};

export default LanguageSwitcher;
